<template>
    <v-container fluid fill-height class="d-flex flex-column flex-nowrap pa-0">

      <!-- MAIN SCHEDULE COLUMN AREA-->
      <div id="scrollArea" class="flex-grow-1 overflow-auto" style="width:100%;">
        <div class="d-flex overflow-x-auto fill-height flex-grow-0 pa-1" ref='sortable'>
            <TaskColumn
              v-for="tt in taskTypes" :key="tt.xid" :sortable-id='tt.xid' ref="taskType"
              :taskType="tt"
            />
        </div>
      </div>

      <!-- TOOLBAR -->
      <div id="toolbarArea" class="" style="width:100%;position:relative;">
        <v-divider />
        <div class="grey lighten-3 pa-2 text-caption">
          <v-btn small color="primary mr-4">...</v-btn>
          <!--
          <v-btn small color="primary mr-4" @click="OpenScheduleList">Manage Schedules</v-btn>
          <v-btn small color="primary mr-4" @click="ClearJobQueue">Clear All</v-btn>
          <v-btn small color="primary mr-4" @click="ClearOldJobTasks">Clear Old</v-btn>
          <v-btn small color="primary mr-4" @click="OpenJobQueue">Job Queue</v-btn>
          <v-btn small color="primary mr-4" @click="SortAll">Sort All</v-btn>
          <v-btn small color="primary mr-4" @click="Print">Print</v-btn>
        -->
        </div>
      </div>

      <!-- EMBEDDED COMPONENTS -->
       <!--
      <ScheduleList ref="ScheduleList" @changed="refreshSchedules" />
      <JobQueue ref="JobQueue" @schedulesChanged="refreshSchedules" @taskflow="showTaskflow" />
      <PrintSchedules ref="PrintSchedules" />
      <Taskflow ref="Taskflow" type="job" :id="taskflowJobId" />
    -->

    </v-container>
</template>

<style lang="scss" scoped>
</style>


<script>
import { /* mapGetters, */  mapActions } from 'vuex';
//import Sortable from 'sortablejs'
//import ScheduleList from '@/components/Schedule/ScheduleList';
import TaskColumn from './TaskColumn'
//import PrintSchedules from '@/components/Schedule/Print'
//import Unscheduled from '@/components/Schedule/Unscheduled'
//import JobQueue from '@/components/Schedule/JobQueue'
//import Taskflow from '@/components/Dialogs/Taskflow'
//import moment from 'moment'

export default {
  name: 'TaskPriorities',
  components: {
    //ScheduleList, JobQueue, PrintSchedules, Taskflow
    TaskColumn,
  },
  data(){
    return {
      taskTypes: [],
    };
  },
  computed: {
  },
  watch: {
    $route: { handler(){ this.SET_TITLE('Task Priority'); }, immediate: true },
  },
  methods: {
    ...mapActions("UI", ["SET_TITLE", 'CONFIRM']),
    ...mapActions("API", ["API"]),

    loadTaskTypes(){
      this.schedules = [];
      return this.API({ method: 'GET', endpoint: 'taskTypes' })
      .then(taskTypes => {
        //this.taskTypes = [taskTypes[0], taskTypes[1], taskTypes[2], taskTypes[3], taskTypes[4]];
        this.taskTypes = taskTypes;
      })
    },

  },

  mounted(){
    this.$nextTick(() => { this.$parent.$parent.$refs.drawer.open = false });
    this.loadTaskTypes();
  },

  beforeDestroy(){
    this.$parent.$parent.$refs.drawer.open = true;
  }


}
</script>
